import '@stimulus/polyfills'
import '../src/utils/localStorage_protection'
import { Application } from '@hotwired/stimulus'
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'
import AsyncFrameController from '../src/common/async_frame_controller'

function importAll (r) {
  r.keys().forEach(r)
}
importAll(require.context('../../components/site/pages/nursing_facilities', true, /desktop\/component\.js$/))
importAll(require.context('../../components/site/pages/national_facilities', true, /desktop\/component\.js$/))
importAll(require.context('../../components/site/pages/special_feature_facilities', true, /desktop\/component\.js$/))
importAll(require.context('../../components/site/pages/facility', true, /desktop\/component\.js$/))
importAll(require.context('../../components/site/parts', true, /desktop\/component\.js$/))
importAll(require.context('../src/common', true, /.*\.js$/))

const application = Application.start()
application.load(definitionsFromContext(require.context('../../components/site/pages/nursing_facilities', true, /desktop\/component_controller\.js$/)))
application.load(definitionsFromContext(require.context('../../components/site/pages/national_facilities', true, /desktop\/component_controller\.js$/)))
application.load(definitionsFromContext(require.context('../../components/site/pages/special_feature_facilities', true, /desktop\/component_controller\.js$/)))
application.load(definitionsFromContext(require.context('../../components/site/pages/facility', true, /desktop\/component_controller\.js$/)))
application.load(definitionsFromContext(require.context('../../components/site/parts', true, /desktop\/component_controller\.js$/)))

// 非同期フレームコントローラーを登録（Turbo Frameの代替）
application.register('async-frame', AsyncFrameController)

const images = require.context('../images', true)
export { images }
